interface RelevanceAnswerOption {
  key?: string;
  Key?: string;
  countryId?: string;
  CountryId?: string;
}

export function hasAnswerKey(options: RelevanceAnswerOption[] | null | undefined, expectedKey: string): boolean {
  return options?.some((option) => option?.key === expectedKey || option?.Key === expectedKey) ?? false;
}

export function hasCountryAnswer(
  options: RelevanceAnswerOption[] | null | undefined,
  expectedCountryId: string
): boolean {
  return options?.some((option) => (option?.countryId ?? option?.CountryId) === expectedCountryId) ?? false;
}
